import { addDays } from 'date-fns';

import isSelectable from './isSelectable';
import isSelected from './isSelected';
import { BlankCalendarDay, DateObj, DatePickerDate } from '../types';

export default function fillFrontWeek({
  firstDayOfMonth,
  minDate,
  maxDate,
  selectedDates,
  firstDayOfWeek,
  showOutsideDays,
}: {
  firstDayOfMonth: Date;
  minDate?: DatePickerDate | null;
  maxDate?: DatePickerDate | null;
  selectedDates: (DatePickerDate | null)[] | null;
  firstDayOfWeek: number;
  showOutsideDays?: boolean;
}) {
  const dates: (BlankCalendarDay | DateObj)[] = [];
  let firstDay = (firstDayOfMonth.getDay() + 7 - firstDayOfWeek) % 7;

  if (showOutsideDays) {
    const lastDayOfPrevMonth = addDays(firstDayOfMonth, -1);
    const prevDate = lastDayOfPrevMonth.getDate();
    const prevDateMonth = lastDayOfPrevMonth.getMonth();
    const prevDateYear = lastDayOfPrevMonth.getFullYear();

    // Fill out front week for days from
    // preceding month with dates from previous month.
    let counter = 0;
    while (counter < firstDay) {
      const date = new Date(prevDateYear, prevDateMonth, prevDate - counter);
      const dateObj = {
        date,
        isOutside: true,
        selected: isSelected(selectedDates, date),
        selectable: isSelectable({ minDate, maxDate, date }),
        today: false,
        prevMonth: true,
        nextMonth: false,
      };
      dates.unshift(dateObj);
      counter++;
    }
  } else {
    // Fill out front week for days from
    // preceding month with buffer.
    while (firstDay > 0) {
      dates.unshift('');
      firstDay--;
    }
  }

  return dates;
}
